function internalRedirectsPathPrefix(marketId) {
  if (marketId) {
    return `/api/internal-redirects/${marketId}`;
  }
  return `/api/internal-redirects`;
}

function internalRedirectsPathPrefixWithFallback(marketId) {
  const DEFAULT_MARKET = "IT";
  return internalRedirectsPathPrefix(marketId ?? DEFAULT_MARKET);
}

function buildProductPath(pathname) {
  const paths = pathname.split('/');
  const handle = paths[paths.length - 1];
  return `${internalRedirectsPathPrefix()}/product/${handle}`;
}

function buildAccountPath(marketId, pathname, search) {
  const accountPathPrefix = `${internalRedirectsPathPrefix(marketId)}/account`;
  if (pathname.includes("/account/activate/")) {
      const afterActivate = pathname.split("/account/activate/")[1]
      const [customerId, activationToken] = afterActivate.split("/")
      return `${accountPathPrefix}/activate?customerId=${customerId}&activationToken=${activationToken}`
  } else if (pathname.includes("/account/reset/")) {
      const afterReset = pathname.split("/account/reset/")[1]
      const [customerId, resetToken] = afterReset.split("/")
      return `${accountPathPrefix}/reset?customerId=${customerId}&resetToken=${resetToken}`
  } else {
      if (pathname.includes("invalid_token") || search.includes("invalid_token")) {
          return `${accountPathPrefix}/invalid_token`
      } else {
          return `${accountPathPrefix}/login`
      }
  }
}

function getMapping(mapping, windowLocation) {
  const { host, protocol } = windowLocation;
  const value = mapping[host] || mapping[`${protocol}//${host}`];
  return value;
}

const transformUrlMarketToMarket = (marketId) => {
  switch (marketId.toLowerCase()) {
    case 'it':
      return 'IT';
    case 'fr':
      return 'FR';
    case 'eu':
      return 'EU';
    case 'uk':
      return 'UK';
    case 'us':
      return 'US';
    default:
      return 'WW';
  }
};

function redirectToDiscount(marketId, pathname) {
  const tokens = pathname.split("/discount/")
  const code = tokens[1];
  return `${internalRedirectsPathPrefix(marketId)}/discount/${code}`
}

function redirectToHome(marketId) {
  return `${internalRedirectsPathPrefix(marketId)}/home`;
}

const redirect = (options, windowLocation) => {
  const { search, pathname } = windowLocation;
  const marketId = getMapping(options.mapping, windowLocation);
  let to_url;
  // const search_params = renameCheckoutUrlQueryParam(search ?? '');
  if (pathname.includes('/products/')) {
    to_url = buildProductPath(pathname);
  } else if (pathname.includes('/account/')) {
      to_url = buildAccountPath(marketId, pathname, search);
  } else if (pathname.includes('/cart')) {
      to_url = redirectToCart(marketId);
  } else if (pathname.includes('/discount/')) {
      to_url = redirectToDiscount(marketId, pathname);
  } else {
      to_url = redirectToHome(marketId);
  }
  return to_url;
}

const redirectToCart = (marketId) => `${internalRedirectsPathPrefixWithFallback(marketId)}/cart`;

// {"en"=>"epoca-wrap-dress", "it"=>"abito-a-portafoglio-epoca"}
const parseJsonMetafield = (str) => {
  try {
    let text = str.replace(new RegExp("=>", 'g'), ":");
    return JSON.parse(text)
  } catch (e) {
    return {};
  }
}

// export functions
if (typeof window != "undefined") {
  window.Xphub = {redirect, redirectToCart, parseJsonMetafield, transformUrlMarketToMarket, redirectToHome, getMapping}
}
